// eslint-disable-next-line @typescript-eslint/typedef
export const BREADCRUMB_NAME = {
    APP_BOOTSTRAP_COMPLETED: 'App bootstrap completed',
    JS_EXCEPTION_WITH_RESPONSE_PAYLOAD: 'JS exception with response payload',
    UNHANDLED_JS_EXCEPTION_CAPTURED: 'Unhandled JS exception captured',
    AUTH_USER_LOGGED_OUT: 'Auth user logged out',
    AUTH_USER_SESSION_IDENTIFIED: 'Auth user session identified',
    NAVIGATION_READY: 'Navigation ready',
    NAVIGATION_ROUTE_CHANGED: 'Navigation route changed',
    LOGIN_API_REQUEST_STARTED: 'Login API request started',
    LOGIN_API_REQUEST_COMPLETED: 'Login API request completed',
    LOGIN_EMAIL_PASSWORD_SUBMITTED: 'Login email/password submitted',
    LOGIN_EMAIL_PASSWORD_SUCCEEDED: 'Login email/password succeeded',
    LOGIN_EMAIL_PASSWORD_FAILED: 'Login email/password failed',
    LOGIN_REQUIRES_IP_CHALLENGE: 'Login requires IP challenge',
    LOGIN_IP_CHALLENGE_SUBMITTED: 'Login IP challenge submitted',
    LOGIN_IP_CHALLENGE_SUCCEEDED: 'Login IP challenge succeeded',
    LOGIN_IP_CHALLENGE_FAILED: 'Login IP challenge failed',
    SOCIAL_LOGIN_SUBMITTED: 'Social login submitted',
    SOCIAL_LOGIN_SUCCEEDED: 'Social login succeeded',
    SOCIAL_LOGIN_FAILED: 'Social login failed',
    REQUEST_QUEUED_WHILE_REFRESHING_AUTH_TOKEN: 'Request queued while refreshing auth token',
    ACCESS_TOKEN_REFRESH_STARTED: 'Access token refresh started',
    ACCESS_TOKEN_REFRESH_SUCCEEDED: 'Access token refresh succeeded',
    ACCESS_TOKEN_REFRESH_FAILED: 'Access token refresh failed',
    CREATE_ORDER_API_REQUEST_STARTED: 'Create order API request started',
    CREATE_ORDER_API_REQUEST_COMPLETED: 'Create order API request completed',
    TRANSACTION_CREATION_REQUESTED: 'Transaction creation requested',
    CREATE_ORDER_VALIDATION_FAILED: 'Create order validation failed',
    CREATE_ORDER_REJECTED_BY_API: 'Create order rejected by API',
    TRANSACTION_CREATION_FAILED: 'Transaction creation failed',
    TRANSACTION_CREATED_SUCCESSFULLY: 'Transaction created successfully',
} as const;

export type BreadcrumbName = (typeof BREADCRUMB_NAME)[keyof typeof BREADCRUMB_NAME];
